import { Notification } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

function UploadNotifications({
  acceptableFileTypes,
  instructions,
  apiError,
  error,
  status,
  maxMb
}) {
  const { t } = useTranslation();

  if (status === 'loading') {
    return <></>;
  }
  if (apiError || error) {
    return (
      <Notification
        message={
          <S.UploadInstructions variant="body2">{apiError?.message || error}</S.UploadInstructions>
        }
        status="error"
        style={{ marginTop: '16px' }}
      />
    );
  }

  return (
    <S.UploadInstructions variant="caption1" color="components-input-fg">
      {instructions?.map(instruction => (
        <S.UploadInstruction key={instruction}>{instruction}</S.UploadInstruction>
      ))}
      {t('fileShouldBe')} {acceptableFileTypes?.join(',')} {t('and')}{' '}
      {t('maxMBWarning', { maxMb: maxMb })}.
    </S.UploadInstructions>
  );
}

export { UploadNotifications };
